export default "__VITE_ASSET__Cp4bqSnx__"